module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "swiper-box"
  }, [_c('swiper', {
    ref: "mySwiper",
    staticClass: "box-container",
    attrs: {
      "options": _vm.swiperOption
    }
  }, [_vm._l((_vm.imgLists), function(item, index) {
    return _c('swiper-slide', {
      key: index,
      nativeOn: {
        "touchmove": function($event) {
          return _vm.stopPlay.apply(null, arguments)
        },
        "touchend": function($event) {
          return _vm.play.apply(null, arguments)
        }
      }
    }, [_c('img', {
      staticClass: "swiper-image",
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "src": item.url,
        "alt": ""
      },
      on: {
        "click": function($event) {
          return _vm.imgclick(item.blog)
        }
      }
    })])
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-pagination",
    attrs: {
      "slot": "pagination"
    },
    slot: "pagination"
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-scrollbar",
    attrs: {
      "slot": "scrollbar"
    },
    slot: "scrollbar"
  })], 2)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "type": "flex",
      "justify": "center"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 23
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "xs": 23,
      "sm": 23,
      "md": 8,
      "lg": 8,
      "xl": 8
    }
  }, [_c('card', {
    attrs: {
      "cardInfo": _vm.cardObject1
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 23,
      "sm": 23,
      "md": 8,
      "lg": 8,
      "xl": 8
    }
  }, [_c('card', {
    attrs: {
      "cardInfo": _vm.cardObject2
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 23,
      "sm": 23,
      "md": 8,
      "lg": 8,
      "xl": 8
    }
  }, [_c('card', {
    attrs: {
      "cardInfo": _vm.cardObject3
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-divider'), _vm._v(" "), _c('el-row', {
    attrs: {
      "type": "flex",
      "justify": "center"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 23
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "xs": 23,
      "sm": 23,
      "md": 4,
      "lg": 4,
      "xl": 4
    }
  }, [_c('recomIcon', {
    attrs: {
      "title": "推薦"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 23,
      "sm": 23,
      "md": 10,
      "lg": 10,
      "xl": 10
    }
  }, [_c('recentMessage', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.newMessageLoading),
      expression: "newMessageLoading"
    }],
    attrs: {
      "title": _vm.itemTitle2,
      "itemList": _vm.newMessageList,
      "clickurl": _vm.item2url
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 23,
      "sm": 23,
      "md": 10,
      "lg": 10,
      "xl": 10
    }
  }, [_c('specialtopic', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.indexFirstLoading),
      expression: "indexFirstLoading"
    }],
    attrs: {
      "title": _vm.itemTitle1,
      "itemList": _vm.specialtopicList
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 23,
      "sm": 23,
      "md": {
        span: 10,
        offset: 4
      },
      "lg": {
        span: 10,
        offset: 4
      },
      "xl": {
        span: 10,
        offset: 4
      }
    }
  }, [_c('recentupdate', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.indexFirstLoading),
      expression: "indexFirstLoading"
    }],
    attrs: {
      "title": _vm.itemTitle,
      "itemList": _vm.indexFirstList
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 23,
      "sm": 23,
      "md": 10,
      "lg": 10,
      "xl": 10
    }
  }, [_c('recommend', {
    attrs: {
      "title": _vm.itemTitle3,
      "itemList": _vm.item3
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-divider'), _vm._v(" "), _c('el-row', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.indexbottomLoading),
      expression: "indexbottomLoading"
    }],
    staticStyle: {
      "margin-bottom": "100px"
    }
  }, _vm._l((_vm.indexbottom), function(bcard) {
    return _c('el-col', {
      key: bcard.icon,
      attrs: {
        "xs": 24,
        "sm": 24,
        "md": 12,
        "lg": 6,
        "xl": 6
      }
    }, [_c('bottomcard', {
      attrs: {
        "cardInfo": bcard
      }
    })], 1)
  }), 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8cc10b5c","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/Index/index.vue
// module id = 1076
// module chunks = 2